import type React from 'react';
import { useAuth } from '../contexts/AuthContext';

interface SteamLoginButtonProps {
  className?: string;
}

export const SteamLoginButton: React.FC<SteamLoginButtonProps> = ({ className = '' }) => {
  const { login } = useAuth();

  return (
    <button
      onClick={login}
      className={`inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-gray-900 hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors ${className}`}
    >
      <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        {/* Steam logo SVG */}
        <path d="M11.979 0C5.678 0 0.511 4.86 0.022 11.037l6.432 2.658c0.545-0.371 1.203-0.59 1.912-0.59c0.063 0 0.125 0.004 0.188 0.006l2.861-4.142c0-0.018-0.001-0.036-0.001-0.055c0-2.32 1.888-4.208 4.208-4.208s4.208 1.888 4.208 4.208s-1.888 4.208-4.208 4.208c-0.018 0-0.036-0.001-0.055-0.001l-4.142 2.861c0.002 0.063 0.006 0.125 0.006 0.188c0 1.834-1.491 3.325-3.325 3.325c-1.666 0-3.047-1.225-3.269-2.833l-4.611-1.906c1.111 5.056 5.51 8.65 10.979 8.65c6.075 0 11-4.925 11-11S18.054 0 11.979 0z" />
        <path d="M7.5 21.3c0.9 0 1.7-0.6 1.9-1.5l1.9 0.8c-0.3 1.2-1.5 2.1-2.8 2.1c-1.7 0-3-1.3-3-3s1.3-3 3-3c0.4 0 0.8 0.1 1.2 0.3l-1.9 0.8C7.2 18.1 6.8 18.5 6.8 19C6.8 20.2 7.3 21.3 7.5 21.3z" />
        <circle cx="15.5" cy="8.5" r="2.5" />
      </svg>
      Sign in with Steam
    </button>
  );
};
